export default "__VITE_ASSET__DxtYrBwd__"